define('shoptheme/components/blocks/fce/newsletter-subscribe-landingpage',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'text!shoptheme/templates/magnific-popup/default.html',
	'magnific-popup'
], function(
	$,
	_,
	Component,
	BEM,
	PopupHtml
) {

	var popupTemplate = null;

	function NewsletterSignupBlock(blockName) {
		this.blocks = BEM.block(blockName);

		var legalTextClassName = BEM.buildElementClassname(blockName, 'legal-text'),
			items = this.blocks.getElements('legal-link'),
			topicsContainer = this.blocks.getElements('topics'),
			topics = topicsContainer.find('input[type=checkbox]'),
			topicLabels = topicsContainer.find('label'),
			selectAll = this.blocks.getElements('select-all'),
			exampleImageContainer = this.blocks.getElements('example-images'),
			exampleImages = exampleImageContainer.find('img'),
			self = this;

		exampleImages.click(function(e) {
			e.preventDefault();
			var message = $(this).parent().prop('outerHTML');
			self._showMessage('', message);
		});

		selectAll.on('change', function() {
			if ($(this).prop('checked')) {
				topics.attr('checked', true);
				topicLabels.addClass('checked');
				topics.addClass('checked');
			} else {
				topics.attr('checked', false);
				topicLabels.removeClass('checked');
				topics.removeClass('checked');
			}
		});

		items.click(function(e) {
			e.preventDefault();
			// var title = $(this).html();
			var title = '';
			var message = $(this).parent().next('.'+legalTextClassName).html();
			self._showMessage(title, message);
		});
	}

	NewsletterSignupBlock.prototype = {
		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		},

		_showMessage: function(title, message) {
			$.magnificPopup.open({
				items: {
					src: this._renderPopup({
						title: title,
						body: message
					}),
					type: 'inline'
				}
			});
		}
	};

	return Component.create({
		$init: function() {
			$.each(['newsletter-subscribe-landingpage', 'newsletter-subscribe-minimal'], function(_key, blockName) {
				new NewsletterSignupBlock(blockName);
			});
		}
	});
});

